import React, { useEffect, useState } from 'react';
import './ReportBootstrapGrid.css';

export function FullscreenIcon() {
  return (
    <svg viewBox="0 0 16 16" aria-hidden="true">
      <path d="M2 6V2h4M10 2h4v4M14 10v4h-4M6 14H2v-4" />
    </svg>
  );
}

export function FullscreenExitIcon() {
  return (
    <svg viewBox="0 0 16 16" aria-hidden="true">
      <path d="M6 2v4H2M10 2v4h4M14 10h-4v4M2 10h4v4" />
    </svg>
  );
}

export function ReportFullscreenButton({ pressed, onClick }) {
  return (
    <button
      type="button"
      className="report-bs-grid__fullscreen-btn"
      aria-pressed={pressed}
      aria-label={pressed ? 'Tam ekrandan çık' : 'Grid tam ekran'}
      title={pressed ? 'Tam ekrandan çık' : 'Grid tam ekran'}
      onClick={onClick}
    >
      {pressed ? <FullscreenExitIcon /> : <FullscreenIcon />}
    </button>
  );
}

export function useReportFullscreen() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (event) => {
      if (event.key === 'Escape') setOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);
  return [open, () => setOpen((value) => !value)];
}

export function ReportFullscreenFrame({ children, className = '' }) {
  const [open, toggle] = useReportFullscreen();
  return (
    <div className={`report-grid-fullscreen ${open ? 'is-fullscreen' : ''} ${className}`.trim()}>
      <div className="report-grid-fullscreen__bar">
        <ReportFullscreenButton pressed={open} onClick={toggle} />
      </div>
      {children}
    </div>
  );
}
